import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Operation } from 'src/app/core/models/operation-log.model';

@Component({
  selector: 'app-operation-table',
  templateUrl: './operation-table.component.html',
})
export class OperationTableComponent {
  @Input() operations: Operation[];
  @Output() openContent = new EventEmitter<Operation>();
}
